import {
  checkoutPaymentWrapperStyling,
  shippingMethodOptionStyling,
  shippingMethodsStyling,
  checkoutBlueprint,
} from "@made-people/blueprint-checkout/blueprint";

checkoutPaymentWrapperStyling.override({
  slots: {
    base: "border border-border-light rounded-md p-4 w-full relative",
  },
});

shippingMethodOptionStyling.override({
  slots: {
    base: "appearance-none grid grid-cols-[min-content_min-content_repeat(10,_1fr)] p-4 border border-solid border-border-dark data-[is-active=true]:border-black rounded-md w-full data-[is-loading=true]:animate-pulse data-[is-loading=true]:border-black transition-colors hover:border-black/50 items-center",
    activeIcon: "col-start-1 col-end-2 place-self-center",
    logo: "col-start-2 col-end-3 place-self-center ml-3 [&>picture]:max-w-10 [&>picture]:w-10 [&>picture]:max-h-10 [&>picture]:flex [&>picture]:items-center",
    label:
      "col-start-3 col-end-11 text-left text-heading-2xs lg:text-heading-xs ml-4 mr-1",
    usps: "col-start-3 col-end-11 text-left text-body-xs mt-2 gap-0.5 flex-col hidden ml-4",
    usp: "",
    price:
      "col-start-11 col-end-13 text-right place-self-stretch text-heading-2xs lg:text-heading-xs",
  },
});

shippingMethodsStyling.override({
  slots: {
    base: "flex flex-col gap-4 items-center w-full mb-8 mt-10",
    headingWrapper:
      "w-full text-left mb-1 [&>h3]:text-heading-sm [&>h3]:lg:text-heading-lg [&>h3]:font-primary",
  },
});

checkoutBlueprint.main.override({
  slots: {
    background:
      "bg-[#faf9f6] py-component-spacing-4xl md:py-component-spacing-4xl lg:py-component-spacing-4xl relative !-mt-8",
    wrapper: "",
    heading: "mb-10 text-center",
    backLink: "!absolute top-12 left-4 font-medium lg:top-16 lg:left-8",
    emptyCart:
      "text-body-lg font-medium text-center h-[40vh] flex justify-center items-center",
  },
});
